import { render, staticRenderFns } from "./productDialog.vue?vue&type=template&id=2b70f2f2&scoped=true"
import script from "./productDialog.vue?vue&type=script&lang=js"
export * from "./productDialog.vue?vue&type=script&lang=js"
import style0 from "./productDialog.vue?vue&type=style&index=0&id=2b70f2f2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b70f2f2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/godata/pipelines/eShop-Portal-Web-Release-Prod/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2b70f2f2')) {
      api.createRecord('2b70f2f2', component.options)
    } else {
      api.reload('2b70f2f2', component.options)
    }
    module.hot.accept("./productDialog.vue?vue&type=template&id=2b70f2f2&scoped=true", function () {
      api.rerender('2b70f2f2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/salesControl/product/components/productDialog.vue"
export default component.exports